var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIsoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 92,
    viewBox: "0 0 96 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.438 31.665L52.4652 1.85062C49.7173 -0.200207 45.8832 -0.200207 43.1353 1.85062L3.16251 31.665C1.29051 33.058 0.194336 35.2153 0.194336 37.5031V84.5609C0.194336 88.6336 3.61299 91.9371 7.8275 91.9371H47.8002V53.31C47.8002 49.2373 51.2189 45.9338 55.4334 45.9338H95.4061V37.5031C95.4061 35.2153 94.31 33.058 92.438 31.665Z",
    fill: "#2FB672"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7696 91.9397C91.9841 91.9397 95.4028 88.6361 95.4028 84.5634V45.9363L47.7969 91.9397H87.7696Z",
    fill: "#DEE8D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7969 53.3125V91.9397L95.4028 45.9363H55.43C51.2155 45.9363 47.7969 49.2399 47.7969 53.3125Z",
    fill: "#013723"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsoLogo);
export default __webpack_public_path__ + "static/media/iso_logo.553f32c30f4a68b7e86f02adccfd7909.svg";
export { ForwardRef as ReactComponent };